import * as z from "zod";

export const tagExtendFormSchema = z.object({
  koLabel: z
    .string()
    .min(1, "한글 라벨을 입력해주세요.")
    .regex(/^[^;]*$/, "; 문자는 사용할 수 없습니다."),
  enLabel: z
    .string()
    .min(1, "영문 라벨을 입력해주세요.")
    .regex(/^[^;]*$/, "; 문자는 사용할 수 없습니다.")
    .regex(/^[^가-힣]+$/, "한글은 입력할 수 없습니다."),
  parentTagKey: z.string().min(1, "축을 선택해주세요."),
});
